import { memo, useCallback, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Zoom } from 'swiper/modules';
import { useMedia } from '../../media.context';
import { MediaFile } from './media-file';

export const Carousel = memo(() => {
  const { files, previewer } = useMedia();
  const videoRefs = useRef<Map<string, HTMLVideoElement>>(new Map());

  const handleSlideChange = (
    swiper: Parameters<typeof previewer.handleSlideChange>[0]
  ) => {
    videoRefs.current.forEach((video) => {
      video.pause();
    });

    previewer.handleSlideChange(swiper);
  };

  const registerVideo = useCallback(
    (el: HTMLVideoElement | null, fileId: string) => {
      if (el) {
        videoRefs.current.set(fileId, el);
      } else {
        videoRefs.current.delete(fileId);
      }
    },
    []
  );

  return (
    <Swiper
      initialSlide={previewer.openedIndex ?? 0}
      onSwiper={previewer.attachSwiper}
      onBeforeDestroy={() => previewer.attachSwiper(null)}
      onSlideChange={handleSlideChange}
      zoom
      keyboard
      modules={[Zoom, Keyboard]}
      grabCursor
      style={{
        height: '100%',
      }}
    >
      {files.map((file) => (
        <SwiperSlide
          key={file.id}
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <MediaFile
            file={file}
            registerVideo={(el) => registerVideo(el, file.id)}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
});
